import EventEmitter from "events";

export interface ILog {
    error: (message: string, data: any | null) => void;
    warning: (message: string, data?: any | null) => void;
    info: (message: string, data?: any | null) => void;
}

export enum LogEntryType {
    Info = 0,
    Error = 1,
    Warning = 2
}

export interface ILogEntry {
    at: Date,
    type: LogEntryType;
    message: string;
    data?: any | null;
}

export interface ILogEntries extends EventEmitter { 
    entries: ILogEntry[];
}